import {
    List,
    ListItem,
    Typography,
    ListItemSecondaryAction,
    Paper,
    Divider,
    ListItemIcon,
    Grid,
    Box,
    Button,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import * as PXBColors from '@brightlayer-ui/colors';
import { DeleteForever } from '@mui/icons-material';
import { StarFishChildDeviceList } from './StarFishChildDeviceList';
import { useHistory } from 'react-router';
import React, { useState, useEffect } from 'react';
import { ContentContainer } from '../ContentContainer';
import { isDataLoaded, Status } from '../../types';
import { AppRoute } from '../../routes';
import { StatusTag } from '../StatusTag/StatusTag';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import deviceStyles from '../../app/device-management/DeviceStyle';
import { LabelWithSubTitle } from '../LabelWithSubTitle/LabelWithSubtitle';
import { NavigationHeader } from '../NavigationHeader/NavigationHeader';
import { DataProviderCache } from '../../data/DataProviders/DataProviderCache';
import { useSignalRSiteData } from '../../data/DataProviders/SignalRSiteDataProvider';
import _ from 'lodash';
import {
    StarfishGatewayDeviceDetailsProvider,
    useStarfishDeviceDetails,
} from '../../data/DataProviders/StarfishGatewayDeviceDetailsProvider';
import { StarfishDeviceData } from '../../types/device';
import { pushAppRoute } from '../../data/domain/route-manager';
import { useDispatch, useSelector } from 'react-redux';
import { Thunks } from '../../actions';
import { useAuthHelper } from '../AuthContextProvider';
import { useToasts } from '../../data/DataProviders/ToastProvider';
import { DeleteConfirmModal } from '../CommonDeleteModals/DeleteConfirmModal';
import { DeleteSFGatewayModal } from './DeleteSFGatewayModal';
import { Selectors } from '../../selectors';

export const StarfishDeviceProfileData: React.FC<{
    backAppRoute: AppRoute;
    data: StarfishDeviceData | null;
    childDeviceList: any[];
}> = (props) => {
    const currentAppRoute = useCurrentAppRoute();
    const starfishDeviceDetails = useStarfishDeviceDetails();
    const { addToast } = useToasts();
    const history = useHistory();
    const dispatch = useDispatch();
    const authHelper = useAuthHelper();
    const classes = deviceStyles();
    const [deviceStatus, setDeviceStatus] = React.useState<boolean | null>();
    const [siteName, setSiteName] = useState('');
    const realTimeSiteData = useSignalRSiteData();
    const [open, setOpen] = React.useState(false);
    const [openConfirm, setOpenConfirm] = React.useState(false);
    const [hours, setHours] = React.useState<number | null>();
    const gatewayDeviceData = useSelector(Selectors.StarfishDevice.deviceRegistration);

    useEffect(() => {
        if (props.data) {
            setDeviceStatus(props.data.status);
            setSiteName(props.data.siteName || '');
        }
    }, [props.data]);
    useEffect(() => {
        if (props.data) {
            if (props.data.pushRate < 60) {
                setHours(props.data.pushRate);
            } else {
                setHours(Math.trunc(props.data.pushRate / 60));
            }
        }
    }, [props.data]);

    const navigateToSiteProfile = (): void => {
        if (currentAppRoute.type === 'StarfishDeviceProfile')
            pushAppRoute(history, {
                type: 'SiteProfile',
                orgId: currentAppRoute.orgId,
                locationId: currentAppRoute.locationId,
                siteId: currentAppRoute.siteId,
            });
        //   dispatch(Actions.SierraDevices.sierraChildDeviceRegistrationUnmounted());
    };

    const handleEditDialogOpen = (): void => {
        if (currentAppRoute.type === 'StarfishDeviceProfile')
            pushAppRoute(history, {
                type: 'EditStarfishConnectedDevice',
                deviceId: currentAppRoute.deviceId,
                locationId: currentAppRoute.locationId,
                orgId: currentAppRoute.orgId,
                siteId: currentAppRoute.siteId,
            });
    };
    useEffect(() => {
        if (realTimeSiteData && realTimeSiteData.devices) {
            if (props.data) {
                const updatedDeviceStatus = _.find(realTimeSiteData.devices, {
                    deviceId: props.data.deviceId,
                });
                if (updatedDeviceStatus) {
                    setDeviceStatus(updatedDeviceStatus.status);
                    setSiteName(props.data.siteName || '');
                }
            }
        }
    }, [realTimeSiteData]);

    React.useEffect(() => {
        if (gatewayDeviceData.deleteGatewayMessage) {
            if (props.data && props.data.name) {
                addToast(`${props.data.name} deleted successfully`);
            }
            navigateToSiteProfile();
        }
    }, [gatewayDeviceData.deleteGatewayMessage]);

    const handleClose = (): void => {
        setOpen(false);
    };

    const handleDelete = (): void => {
        handleClose();
        if (props.data)
            dispatch(Thunks.StarfishDevice.DeleteStarfishGateway(props.data.deviceId, authHelper, addToast));
    };
    const handleConfirmClose = (): void => {
        setOpenConfirm(false);
    };

    const onContinue = (): void => {
        setOpen(false);
        setOpenConfirm(true);
    };
    const onDelete = (): void => {
        setOpen(true);
    };
    return (
        <>
            <ContentContainer>
                {props.data &&
                    currentAppRoute.type === 'StarfishDeviceProfile' &&
                    props.data &&
                    isDataLoaded(starfishDeviceDetails) && (
                        <>
                            <NavigationHeader
                                for="Connected Device"
                                siteName={siteName}
                                connectedDevice={props.data.name || ''}
                                device={''}
                            />
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={6}>
                                    <Paper>
                                        <List>
                                            <ListItem data-testid="device-name">
                                                <Typography variant="h6" color="primary">
                                                    {props.data.name}
                                                </Typography>

                                                <ListItemSecondaryAction>
                                                    <ListItemIcon
                                                        data-testid="device-status-icon"
                                                        style={{ display: 'block' }}
                                                    >
                                                        {deviceStatus ? (
                                                            <StatusTag
                                                                status={Status.Online}
                                                                style={{ marginRight: 30 }}
                                                            />
                                                        ) : (
                                                            <StatusTag
                                                                status={Status.Offline}
                                                                style={{ marginRight: 30 }}
                                                            />
                                                        )}
                                                    </ListItemIcon>
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                            <ListItem data-testid="device-type" className={classes.margin8}>
                                                <LabelWithSubTitle
                                                    title={props.data.family}
                                                    subTitle=" Connected Device Type"
                                                />
                                            </ListItem>

                                            <Divider />
                                            <ListItem data-testid="id" className={classes.margin8}>
                                                <LabelWithSubTitle
                                                    title={props.data.deviceId}
                                                    subTitle="Gateway Device ID (To enable your physical gateway configure this ID in it)"
                                                />
                                            </ListItem>
                                            <Divider />
                                            <ListItem data-testid="ip-address" className={classes.margin8}>
                                                <LabelWithSubTitle title={props.data.deviceIP} subTitle="Device IP" />
                                            </ListItem>
                                            <Divider />
                                            <ListItem data-testid="serial-number" className={classes.margin8}>
                                                <LabelWithSubTitle title={props.data.serial} subTitle="Serial" />
                                            </ListItem>
                                            <Divider />
                                            <ListItem data-testid="mac" className={classes.margin8}>
                                                <LabelWithSubTitle title={props.data.mac} subTitle="Mac" />
                                            </ListItem>
                                            <Divider />
                                            <ListItem data-testid="push-rate" className={classes.margin8}>
                                                <LabelWithSubTitle
                                                    title={
                                                        props.data.pushRate < 60 ? `00:${hours} min` : `${hours}:00 hr`
                                                    }
                                                    subTitle="Publish Rate"
                                                />
                                            </ListItem>
                                            <Divider />

                                            <div
                                                style={{
                                                    margin: 16,
                                                    display: 'flex',
                                                    justifyContent: 'space-evenly',
                                                }}
                                            >
                                                <Box>
                                                    <Button
                                                        style={{ marginRight: 15 }}
                                                        variant="contained"
                                                        color="primary"
                                                        startIcon={<EditIcon />}
                                                        data-testid="edit-action"
                                                        onClick={handleEditDialogOpen}
                                                    >
                                                        Edit Connected Device
                                                    </Button>
                                                </Box>
                                                <Box>
                                                    <Button
                                                        style={{
                                                            color: PXBColors.red[500],
                                                            borderColor: PXBColors.gray[100],
                                                        }}
                                                        variant="outlined"
                                                        startIcon={<DeleteForever />}
                                                        data-testid="delete-action"
                                                        onClick={(): void => {
                                                            onDelete();
                                                        }}
                                                    >
                                                        Delete Forever
                                                    </Button>
                                                </Box>
                                            </div>
                                        </List>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <DataProviderCache for={'device-details-child-list'}>
                                        <StarfishGatewayDeviceDetailsProvider deviceId={props.data.deviceId}>
                                            <StarFishChildDeviceList
                                                childDeviceDetails={props.childDeviceList}
                                                parentDeviceId={props.data.deviceId}
                                            />

                                            <DeleteSFGatewayModal
                                                open={open}
                                                onClose={handleClose}
                                                handleContinue={onContinue}
                                                name={props.data.name}
                                            />
                                            <DeleteConfirmModal
                                                open={openConfirm}
                                                onClose={handleConfirmClose}
                                                name={props.data.name}
                                                handleDelete={handleDelete}
                                                navigateFn={navigateToSiteProfile}
                                            />
                                        </StarfishGatewayDeviceDetailsProvider>
                                    </DataProviderCache>
                                </Grid>
                            </Grid>
                        </>
                    )}
            </ContentContainer>
        </>
    );
};
